import { useDispatch, useSelector } from "react-redux";
import { FormControl, FormLabel, Stack, TextField } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { addFilterCompanyName } from "../../state/jobPostList/jobPostListSlice";
import { selectJobPostFilters } from "../../state/jobPostList/jobPostListSelector";
import PageTitle from "../../common/PageTitle";

const JobPostListHeader = () => {
  const dispatch = useDispatch();
  const { companyName } = useSelector(selectJobPostFilters);

  const handleSearchChange = (e) => {
    dispatch(addFilterCompanyName(e.target.value));
  };

  return (
    <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "flex-start", md: "center" }} justifyContent={"space-between"} spacing={2} mb={3}>
      <PageTitle title={"Jobs"} mb={0} subTitleMb={0} />
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "stretch", sm: "flex-end" }} sx={{ width: { xs: "100%", md: "auto" } }}>
        <FormControl sx={{ flexGrow: 1, minWidth: { xs: "100%", sm: 200 }, maxWidth: { md: 330 } }}>
          <FormLabel>Search By Company Name:</FormLabel>
          <TextField
            size={"small"}
            type={"search"}
            placeholder={"Search..."}
            value={companyName || ""}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: <SearchRoundedIcon fontSize={"small"} color={"action"} sx={{ ml: 1 }} />,
            }}
          />
        </FormControl>
      </Stack>
    </Stack>
  );
};

export default JobPostListHeader;
